import { openModal } from "action/modal/openModal";
import classnames from "classnames";
import Link from "next/link";
import { useDispatch } from "react-redux";
import { getLinkProps } from "../../util/url/getLinkProps";
import CategoryViewItem from "../categories-viewer/CategoryViewItem";
import styles from "./breadcrumbV2.module.scss";

function BreadcrumLi(props: any) {
  const {
    title, url, isLast, pageType, categoryObj, index, href,
  } = props;
  const label = title?.replace(/parts|& parts/i, "");
  const seprator = !isLast ? (
    <span className={styles.breadcrumbs_separator}>
      &gt;
    </span>
  ) : null;

  const dispatch = useDispatch();

  if (url) {
    return (
      <li>
        <Link {...getLinkProps({ href, url })}>
          {label}
        </Link>
        {seprator}
      </li>
    );
  }

  if (title === "Search") {
    return (
      <li onClick={() => dispatch(openModal("searchModal"))}>
        {label}
        {seprator}
      </li>
    );
  }

  if (categoryObj) {
    return (
      <li className={classnames({
        [styles.disable_breadcrumb]: !url,
      })}
      >

        <CategoryViewItem
          categoryObj={categoryObj}
          key={`${pageType} ${index}`}
        >

          <>
            {label}
            {seprator}
          </>
        </CategoryViewItem>
      </li>
    );
  }

  return (
    <li className={classnames({
      [styles.disable_breadcrumb]: !url,
    })}
    >
      {label}
      {seprator}
    </li>
  );
}

export default BreadcrumLi;
